import { Component, OnInit } from '@angular/core';
import { ProgressSpinnerMode, ThemePalette } from '@angular/material';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-by-product-gatepass-history',
  templateUrl: './by-product-gatepass-history.component.html',
  styleUrls: ['./by-product-gatepass-history.component.scss']
})
export class ByProductGatepassHistoryComponent implements OnInit {
  title = '';
  selected_business_code = null;
  by_product_order_list: any = [];
  enable_order_data = false;
  is_data_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';

  constructor(private globalService: GlobalService, private httpService: HttpService) { 
    this.title = this.globalService._active_display_name;
   }

  getBusinessByProductOrder() {
    this.enable_order_data = true;
    let data_dict = {
      'business_code': this.selected_business_code
    };
    this.is_data_available = false;
    this.httpService.serveByProductOrderForSelectedBusiness(data_dict).subscribe((data) => {
      console.log(data);
      this.by_product_order_list = data;
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
      console.error(error);
    });
  }
  
  downloadGatePass(by_sale_group_id, document_for) {
    let data_dict = {
      'by_sale_group_id': by_sale_group_id,
      'count': 1,
      'for': document_for
    };
    this.httpService.downloadByProductGatePass(data_dict).subscribe((data) => {
      console.log(data);
      const linkSource = 'data:application/pdf;base64,' + data['pdf'];
      const downloadLink = document.createElement("a");
      const fileName = data['file_name'];
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }, (error) => {
      console.error(error);
    });
  }

  ngOnInit() {
  }

}
